import * as React from 'react';
import * as _ from 'lodash';

import { goToPage, prevPage, nextPage } from './actions';
import { directoryDispatch } from './affiliate-directory';

interface IDirectoryPages
{
  currentPage: number,
  pageCount: number,
  resultsCount: number
}

class DirectoryPagination extends React.Component<IDirectoryPages, any>{
  constructor(props)
  {
    super( props );
  }

  onFirstButtonClick(e)
  {
    directoryDispatch()( goToPage( 1 ) );
    this.scrollUp();
  }

  onPrevButtonClick(e)
  {
    directoryDispatch()( prevPage() );
    this.scrollUp();
  }

  onNextButtonClick(e)
  {
    directoryDispatch()( nextPage() );
    this.scrollUp();
  }

  onLastButtonClick(e)
  {
    directoryDispatch()( goToPage( this.props.pageCount ) );
    this.scrollUp();
  }

  onPageNumberClick(e)
  {
    directoryDispatch()( goToPage( e.target.value ) );
    this.scrollUp();
  }

  disabledClick( e ) {
    e.preventDefault();
  }

  scrollUp() {
      window.scrollTo(0, 0);
  }
 
  render()
  {
    var pageIndex = 1;
    var pageSets = _.times(this.props.pageCount / 6, n =>
    {
      var pageArray = [];
      for (var i = pageIndex; i <= (pageIndex + 5 >= this.props.pageCount ? this.props.pageCount : pageIndex + 5 ); i++) {
        pageArray.push(i);
      }
      pageIndex = pageIndex + 6;
      return pageArray;
    })

    var currentPageSetIndex = _.findIndex(pageSets, set =>
    {
      return set.indexOf(this.props.currentPage + 1) >= 0;
    });
    // tells which index range page is in

    return (
      <div className="directory-pagination-container">
        <div className="pagination">
          <div className="pagination-pages-prev">
            <div className="pagination-back pagination-back-all">
              <button type="button" className={this.props.currentPage + 1 > 1 ? "pagination-btn " : "pagination-btn btn-disabled"} disabled={this.props.resultsCount < 10 ? true : false} onClick={this.onFirstButtonClick.bind(this)}>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-double-chevron"></use>
                </svg>
                <span className="text pagination-text">
                  First
                    </span>
              </button>
            </div>

            <div className="pagination-back pagination-back-one">
              <button type="button" className={this.props.currentPage >= 1 ? "pagination-btn " : "pagination-btn btn-disabled"} disabled={this.props.resultsCount < 10 ? true : false} onClick={this.onPrevButtonClick.bind(this)}>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron"></use>
                </svg>
                <span className="text pagination-text">
                  Previous
                    </span>
              </button>
            </div>
          </div>
          

          {(this.props.pageCount > 6) ? (
            <ul className="pagination-count pagination-pages-count">

              {currentPageSetIndex > 0 ?
                <div>
                  <span className="pagination-first-page"><button type="button" value="1" onClick={this.onFirstButtonClick.bind(this)}>1</button></span>
                  <span className="pagination-count-ellipsis">...</span>
                </div>
                : null}

              {pageSets[currentPageSetIndex].map((page) =>
                  {
                    return <li key={page} className={page === this.props.currentPage + 1 ? "active" : ""}><button type="button" value={page} onClick={this.onPageNumberClick.bind(this)}>{page}</button></li>
                })
              }

              {currentPageSetIndex < pageSets.length - 1 ?
                <div>
                  <span className="pagination-count-ellipsis">...</span>
                  <span className="pagination-last-page"><button type="button" value={this.props.pageCount} onClick={this.onLastButtonClick.bind(this)}>{this.props.pageCount}</button></span>
                </div>
              : null } 
            </ul>
            ) : (
              <ul className="pagination-count pagination-pages-count">
                {
                  _.times(this.props.pageCount, n => n + 1).map((page) =>
                  {
                    return <li key={page} className={page === this.props.currentPage + 1 ? "active" : ""}><button type="button" value={page} onClick={this.onPageNumberClick.bind(this)}>{page}</button></li>
                  })
                }
              </ul>
              )
            }
          
          <div className="pagination-pages-next">
            <div className="pagination-forward pagination-forward-one">
              <button type="button" className={this.props.currentPage + 1 < this.props.pageCount ? "pagination-btn " : "pagination-btn btn-disabled"} disabled={this.props.resultsCount < 10 ? true : false} onClick={this.onNextButtonClick.bind( this )}>
                  <span className="text pagination-text">Next</span>
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron"></use>
                  </svg>
                </button>
            </div>

            <div className="pagination-forward pagination-forward-all">
              <button type="button" className={this.props.currentPage + 1 < this.props.pageCount ? "pagination-btn " : "pagination-btn btn-disabled"} disabled={this.props.resultsCount < 10 ? true : false} onClick={this.onLastButtonClick.bind(this)}>
                <span className="text pagination-text">Last</span>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-double-chevron"></use>
                </svg>
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }

}

export default DirectoryPagination;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/directory-pagination.tsx